export default "__VITE_ASSET__c42526e9__"